import React, { useState } from 'react'
import {
  ArrowForwardIos,
  ViewComfy,
  Poll
} from '@material-ui/icons'
import { PropertyListItem } from '@components/custom'
import PropTypes from 'prop-types'
import './PageListContainer.scss'
import Comps from '@engine/comps'
import { connect } from 'react-redux'

const PageListContainer = props => {
  const [dragIndex, setDragIndex] = useState(-1)
  const [dragSubjectIndex, setDragSubjectIndex] = useState(-1)
  const [clickedOnSubjectProp, setClickedOnSubjectProp] = useState(false)
  const [clickedOnComparableProp, setClickedOnComparableProp] = useState(false)
  const {
    propertyData,
    gotoPropertyPreview,
    subject,
    properties,
    handleDeleteClick,
    barChartData,
    reArrangeComps, templateName } = props
  const ignoreListWhen = ['rentCompsT6', 'salesCompsT2']
  const orderIndicies = props.properties.map((_, idx) => idx)
  const enableDelete = subject ? (properties.length > 1) : (properties.length > 2)

  const onDragOver = () => e => {
    e.preventDefault()
    const target = e.currentTarget
    target.className = 'property-list__item dragging'
  }

  const onDragStart = originalIndex => () => {
    setDragIndex(originalIndex)
    setClickedOnComparableProp(true)
  }

  const onDrop = orderIndex => e => {
    if (!clickedOnComparableProp) {
      return
    }
    e.preventDefault()
    const target = e.currentTarget
    target.className = 'property-list__item'
    if (orderIndex === dragIndex) {
      return
    }
    reArrangeComps({ indexFrom: dragIndex, indexTo: orderIndex })
    setClickedOnComparableProp(false)
  }

  const onSubjectDragOver = () => e => {
    e.preventDefault()
    const target = e.currentTarget
    target.className = 'property-list__item dragging'
  }

  const onSubjectDragStart = originalIndex => () => {
    setDragSubjectIndex(originalIndex)
    setClickedOnSubjectProp(true)
  }

  const onSubjectDrop = orderIndex => e => {
    if (!clickedOnSubjectProp) {
      return
    }
    e.preventDefault()
    const target = e.currentTarget
    target.className = 'property-list__item'
    if (orderIndex === dragSubjectIndex) {
      return
    }
    reArrangeComps({ indexFrom: dragSubjectIndex, indexTo: orderIndex, propertyType: 'subject' })
    setClickedOnSubjectProp(false)
  }

  return (
    <div data-testid="property_list_tabItems" className="page-list-tab">
      <div className="arrow-title">
        <div className="arrow-forward">
          <ArrowForwardIos className="right_arrow" />
        </div>
        <div className="page-list-title">
          <span className="title">Page List</span>
          <span className="total-pages">
            {propertyData && propertyData.length + 1} Pages
              </span>
        </div>
      </div>
      <div className="property-list-container">
        <div className="property-list">
          <div
            className="property-list__item"
            data-testid="property_summary"
            onClick={() => gotoPropertyPreview('summary')}
          >
            <span>
              <ViewComfy />
            </span>
            <span>Property Summary</span>
            <span
              data-testid="comps-count"
              className="property-summary-total"
            >
              {' '}
              {propertyData && propertyData.length} Total
              </span>
          </div>
          {subject &&
            subject.map((property, index) => (
              <PropertyListItem
                key={property.propertyType}
                isSubject={true}
                property={property}
                originalIndex={index}
                orderIndex={orderIndicies[index]}
                isDragging={dragSubjectIndex === index}
                dragMode={dragSubjectIndex !== -1}
                onDragOver={onSubjectDragOver}
                onDragStart={onSubjectDragStart}
                onDrop={onSubjectDrop}
                gotoPropertyPreview={gotoPropertyPreview}
                enableDelete={enableDelete}
                onDelete={handleDeleteClick}
              />
            ))}
          {subject && subject.length > 0 && (<hr />)}
          {properties &&
            properties.map((property, index) => (
              <PropertyListItem
                key={index}
                isSubject={false}
                property={property}
                originalIndex={index}
                orderIndex={orderIndicies[index]}
                isDragging={dragIndex === index}
                dragMode={dragIndex !== -1}
                onDragOver={onDragOver}
                onDragStart={onDragStart}
                onDrop={onDrop}
                gotoPropertyPreview={gotoPropertyPreview}
                enableDelete={enableDelete}
                onDelete={handleDeleteClick}
              />
            ))}
          {!ignoreListWhen.includes(templateName) && barChartData && barChartData.length > 0 && (
            <div
              className="property-list__item"
              data-testid="property_barcharts"
              onClick={() => gotoPropertyPreview('barcharts')}
            >
              <span>
                <Poll />
              </span>
              <span>Bar Charts</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

PageListContainer.propTypes = {
  propertyData: PropTypes.array,
  gotoPropertyPreview: PropTypes.func,
  properties: PropTypes.array,
  subject: PropTypes.array,
  reArrangeComps: PropTypes.func,
  barChartData: PropTypes.array,
  handleDeleteClick: PropTypes.func,
  templateName: PropTypes.string
}

const mapStateToProps = state => ({
  templateName: Comps.selectors.comps.templateName(state)
})

export default connect(mapStateToProps)(PageListContainer)
